

























import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseIcon from "@/components/BaseIcon";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "CreatePostMinimizedView",
  components: { BaseSpinner, BaseButton, BaseIcon },
  props: {
    errorUploadingFile: { type: Boolean, default: false },
    isPublished: { type: Boolean, default: false },
    uploadedFilesNumber: { type: Number, default: 0 },
    totalFiles: { type: Number, required: true },
  },
});
